<!-- Hovered -->
<div *ngIf="hoveredSnapshot != null" class="score-sensor-container hovered">
  <div class="title-box device-selected">
    <span class="device-name">{{hoveredSnapshot.deviceName | namize}}</span>
  </div>
  <div class="score-box">
    <awair-score-dot class="__score-dot"
                     [color]="hoveredSnapshot?.score | scoreToColor"
                     [isOnline]="hoveredSnapshot?.isOnline"
                     [score]="hoveredSnapshot?.score">
    </awair-score-dot>
    <div class="__score-text-wrapper">
      <p class="score-label">Awair Score</p>
      <p class="score-status">
        {{hoveredSnapshot?.isOnline ? (hoveredSnapshot?.score | scoreToCondition) : 'Disconnected'}}
      </p>
    </div>
  </div>
  <div class="sensors-box">
    <awair-sensor-component *ngFor="let key of hoveredDeviceKeys"
                            class="__sensor-component"
                            [componentType]="key"
                            [value]="hoveredSnapshot?.isOnline ? hoveredSnapshot?.sensors[key] : null"
                            [temperatureUnit]="temperatureUnit"
                            [sensorColor]="hoveredSnapshot?.isOnline ? (hoveredSnapshot?.index[key] | indexToColor) : '#CDD3D8'">
    </awair-sensor-component>
  </div>
</div>
<!-- /.Hovered -->

<!-- No Selected Device -->
<div *ngIf="!selectedSnapshots[currentIndex]" class="score-sensor-container">
  <div class="title-box">
    Select the device(s)
  </div>
  <div class="score-box">
    <awair-score-dot class="__score-dot"
                     [isOnline]="false">
    </awair-score-dot>
    <div class="__score-text-wrapper">
      <p class="score-label">Awair Score</p>
      <p class="score-status">-</p>
    </div>
  </div>
  <div class="sensors-box">
    <awair-sensor-component class="__sensor-component"
                            [componentType]="AirComponentType.Temperature"
                            [temperatureUnit]="temperatureUnit">
    </awair-sensor-component>
    <awair-sensor-component class="__sensor-component"
                            [componentType]="AirComponentType.Humidity">
    </awair-sensor-component>
    <awair-sensor-component class="__sensor-component"
                            [componentType]="AirComponentType.CO2">
    </awair-sensor-component>
    <awair-sensor-component class="__sensor-component"
                            [componentType]="AirComponentType.Chemicals">
    </awair-sensor-component>
    <awair-sensor-component class="__sensor-component"
                            [componentType]="AirComponentType.Dust">
    </awair-sensor-component>
  </div>
</div>
<!-- /.No Selected Device -->

<!-- Selected Device (Single) -->
<div *ngIf="(selectedSnapshots[currentIndex] != null) && selectedSnapshots.length === 1" class="score-sensor-container">
  <div class="title-box device-selected">
    <span class="device-name">{{selectedSnapshots[currentIndex]?.deviceName}}</span>
    <span class="__spacer"></span>
  </div>
  <div class="score-box">
    <awair-score-dot class="__score-dot"
                     [color]="selectedSnapshots[currentIndex]?.score | scoreToColor"
                     [isOnline]="selectedSnapshots[currentIndex]?.isOnline"
                     [score]="selectedSnapshots[currentIndex]?.score">
    </awair-score-dot>
    <div class="__score-text-wrapper">
      <p class="score-label">Awair Score</p>
      <p class="score-status">
        {{selectedSnapshots[currentIndex]?.isOnline ? (selectedSnapshots[currentIndex]?.score | scoreToCondition) :
        'Disconnected'}}
      </p>
    </div>
  </div>
  <div class="sensors-box">
    <awair-sensor-component *ngFor="let key of selectedDeviceKeys"
                            class="__sensor-component"
                            [componentType]="key"
                            [value]="selectedSnapshots[currentIndex]?.isOnline ? selectedSnapshots[currentIndex]?.sensors[key] : null"
                            [temperatureUnit]="temperatureUnit"
                            [sensorColor]="selectedSnapshots[currentIndex]?.isOnline ? (selectedSnapshots[currentIndex]?.index[key] | indexToColor) : '#CDD3D8'">
    </awair-sensor-component>
  </div>
</div>
<!-- /.Selected Device (Single) -->

<!-- Selected Devices (Multiple) -->
<div *ngIf="(selectedSnapshots[currentIndex] != null) && selectedSnapshots.length > 1" class="score-sensor-container"
     (mouseover)="isHovered = true" (mouseleave)="isHovered = false"
     [@fadeInOut]="selectedSnapshots[currentIndex].deviceUuid">
  <div class="title-box device-selected">

    <span class="device-name">{{selectedSnapshots[currentIndex]?.deviceName}}</span>
    <span class="__spacer"></span>
    <span class="current-device-index">
      {{currentIndex + 1}} / {{selectedSnapshots.length}}
    </span>
  </div>
  <div class="score-box">
    <awair-score-dot class="__score-dot"
                     [color]="selectedSnapshots[currentIndex]?.score | scoreToColor"
                     [isOnline]="selectedSnapshots[currentIndex]?.isOnline"
                     [score]="selectedSnapshots[currentIndex]?.score">
    </awair-score-dot>
    <div class="__score-text-wrapper">
      <p class="score-label">Awair Score</p>
      <p class="score-status">
        {{selectedSnapshots[currentIndex]?.isOnline ? (selectedSnapshots[currentIndex]?.score | scoreToCondition) :
        'Disconnected'}}
      </p>
    </div>
  </div>
  <div class="sensors-box">
    <awair-sensor-component *ngFor="let key of selectedDeviceKeys"
                            class="__sensor-component"
                            [componentType]="key"
                            [value]="selectedSnapshots[currentIndex]?.isOnline ? selectedSnapshots[currentIndex]?.sensors[key] : null"
                            [temperatureUnit]="temperatureUnit"
                            [sensorColor]="selectedSnapshots[currentIndex]?.isOnline ? (selectedSnapshots[currentIndex]?.index[key] | indexToColor) : '#CDD3D8'">
    </awair-sensor-component>
  </div>
  <div class="device-select-button">
    <svg (click)="selectPrev()" style="cursor: pointer" width="48px" height="48px" viewBox="0 0 48 48" version="1.1"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Main" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Grid-View---Buttons" transform="translate(-376.000000, -879.000000)">
          <circle id="Oval-7" fill-opacity="0.5" fill="#434A52" cx="400" cy="903" r="24"></circle>
          <polyline id="Path-9" stroke="#FFFFFF" stroke-width="4"
                    transform="translate(397.500000, 903.000000) scale(-1, 1) translate(-397.500000, -903.000000) "
                    points="393 894 402 903 393 912"></polyline>
        </g>
      </g>
    </svg>

    <svg (click)="selectNext()" style="cursor: pointer" width="48px" height="48px" viewBox="0 0 48 48" version="1.1"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Main" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Grid-View---Buttons" transform="translate(-535.000000, -879.000000)">
          <circle id="Oval-7" fill-opacity="0.5" fill="#434A52" cx="559" cy="903" r="24"></circle>
          <polyline id="Path-9" stroke="#FFFFFF" stroke-width="4" points="555 895.5 564.5 904.75 555 914"></polyline>
        </g>
      </g>
    </svg>
  </div>
</div>
<!-- Selected Devices (Multiple) -->
